import type { FC, ReactElement } from 'react';
import React, { Children, cloneElement } from 'react';
import cn from 'classnames';

import type { TList, TSeoTypes } from './models';

export const List: FC<TList> = ({
    children,
    className,
    horizontal = false,
    indentType = 'default',
    inverted,
    itemClassName,
    marginCollapseFirst = false,
    marginCollapseLast = false,
    marginCollapseVertical = false,
    marginHorizontal = false,
    marker = '•',
    markerColor,
    nowrap = false,
    olRedMarker = false,
    olType,
    styles,
    svgHeight = 'auto',
    svgMargin = '0 8px 0 0',
    svgSrc = '',
    svgWidth = 'auto',
    type = 'div',
}) => {
    let ListParent: TSeoTypes;

    let Item: 'li' | 'div';

    const currentColorStyle = markerColor ? { color: markerColor } : undefined;

    switch (type) {
        case 'ul': {
            ListParent = 'ul';
            Item = 'li';
            break;
        }

        case 'ol': {
            ListParent = 'ol';
            Item = 'li';
            break;
        }

        default: {
            ListParent = 'div';
            Item = 'div';
        }
    }

    return (
        <ListParent
            className={
                // eslint-disable-next-line external-classname/specificity
                cn(
                    styles.list,
                    { [styles.orderedList]: olType, [styles.listNowrap]: nowrap },
                    className
                )
            }
            type={olType}
        >
            {Children.toArray(children).map((child, index) => {
                return (
                    <Item
                        // eslint-disable-next-line react/no-array-index-key
                        key={`listItem-${index}`}
                        className={cn(
                            {
                                [styles.listItem]: !horizontal,
                                [styles.listItemMarker]: !svgSrc,
                                [styles.horizontalListItem]: horizontal,
                                // TODO: Когда будет выпелен indentType, нужно будет оставить только styles.marginDefault, сейчас он не применяется никогда, потому что indentType = 'default' по умолчанию
                                ...(indentType === undefined
                                    ? /* istanbul ignore next */
                                      { [styles.marginDefault]: true }
                                    : indentType === 'none'
                                    ? { indent_none: true }
                                    : {
                                          [styles[`indent_${indentType}`]]: indentType,
                                      }),
                                [styles.marginCollapseFirst]: marginCollapseFirst,
                                [styles.marginCollapseLast]: marginCollapseLast,
                                [styles.marginHorizontal]: marginHorizontal,
                                [styles.marginCollapseVertical]: marginCollapseVertical,
                                [styles.orderedListItem]: olType,
                                [styles.redMarker]: olRedMarker,
                            },
                            itemClassName
                        )}
                    >
                        {(marker || svgSrc) && (
                            <div
                                className={cn(styles.marker, {
                                    [styles.redMarkerInverted]: inverted && !markerColor,
                                    [styles.redMarker]: !inverted && !markerColor,
                                })}
                                style={{
                                    ...currentColorStyle,
                                    margin: svgMargin,
                                    width: svgWidth,
                                    height: svgHeight,
                                }}
                            >
                                {svgSrc ? (
                                    <img
                                        alt="icon"
                                        src={svgSrc}
                                        style={{
                                            width: svgWidth,
                                            height: svgHeight,
                                        }}
                                    />
                                ) : (
                                    marker
                                )}
                            </div>
                        )}

                        {cloneElement(child as ReactElement, {
                            style: { margin: 0, padding: 0 },
                        })}
                    </Item>
                );
            })}
        </ListParent>
    );
};
